/* =========================================================
   LUMINIAIRE FRANCE — WISHLIST
   Coups de cœur • Compteur • Synchronisation
   ========================================================= */

(function () {
  'use strict';

  const STORAGE_KEY =
    'luminaire_france_wishlist_v1';

  const BUTTON_SELECTOR =
    '[data-lf-wishlist-button]';

  /* =====================================================
     LECTURE
     ===================================================== */

  function readWishlist() {
    try {
      const data =
        JSON.parse(
          localStorage.getItem(
            STORAGE_KEY
          ) || '[]'
        );

      if (!Array.isArray(data)) {
        return [];
      }

      return data
        .map(function (item) {

          if (
            typeof item ===
            'string'
          ) {
            return item;
          }

          if (
            item &&
            typeof item ===
            'object'
          ) {
            return (
              item.handle ||
              item.productHandle ||
              item.product_handle ||
              (item.id || item.productId || item.product_id
                ? String(item.id || item.productId || item.product_id)
                : '')
            );
          }

          return '';
        })
        .filter(Boolean);

    } catch (error) {

      console.warn(
        'Luminaire France — wishlist : lecture impossible',
        error
      );

      return [];
    }
  }

  /* =====================================================
     ECRITURE
     ===================================================== */

  function writeWishlist(items) {
    try {

      const unique =
        Array.from(
          new Set(items)
        );

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(unique)
      );

      return unique;

    } catch (error) {

      console.warn(
        'Luminaire France — wishlist : écriture impossible',
        error
      );

      return items;
    }
  }

  /* =====================================================
     COMPTEUR
     ===================================================== */

  function updateWishlistCounters(
    wishlist
  ) {

    const count =
      wishlist.length;

    document
      .querySelectorAll(
        '[data-lf-wishlist-count], .lf-wishlist-header__count'
      )
      .forEach(function (element) {

        element.textContent =
          count;

        /*
         * Si le compteur possède
         * l'attribut hidden,
         * on l'affiche uniquement
         * lorsqu'il y a au moins
         * un coup de cœur.
         */

        element.hidden =
          count === 0;

        element.setAttribute(
          'aria-hidden',
          String(count === 0)
        );

        element.setAttribute(
          'data-wishlist-count-value',
          count
        );
      });
  }

  function normalizedWishlist() {
    const saved = readWishlist();
    const idToHandle = new Map();

    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      const handle = (button.dataset.handle || '').trim();
      const wrapper = button.closest('[data-product-id]');
      const id = button.getAttribute('data-lf-product-id') ||
        button.getAttribute('data-product-id') ||
        (wrapper ? wrapper.getAttribute('data-product-id') : '');
      if (handle && /^\d+$/.test(String(id || ''))) {
        idToHandle.set(String(id), handle);
      }
    });

    const normalized = Array.from(new Set(saved.map(function (item) {
      const key = String(item || '').trim();
      return idToHandle.get(key.replace(/^id:/, '')) || key;
    }).filter(Boolean)));

    if (JSON.stringify(normalized) !== JSON.stringify(saved)) {
      writeWishlist(normalized);
    }
    return normalized;
  }

  /* =====================================================
     SYNCHRONISATION DES COEURS
     ===================================================== */

  function syncWishlist() {

    const wishlist =
      normalizedWishlist();

    document
      .querySelectorAll(
        BUTTON_SELECTOR
      )
      .forEach(function (button) {

        const handle =
          button.dataset.handle;

        if (!handle) return;

        const active =
          wishlist.indexOf(
            handle
          ) !== -1;

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active
            ? 'true'
            : 'false'
        );

        button.setAttribute(
          'aria-label',
          active
            ? 'Retirer des coups de cœur'
            : 'Ajouter aux coups de cœur'
        );
      });

    updateWishlistCounters(
      wishlist
    );

    /*
     * Permet aux autres parties
     * du thème de réagir au changement.
     */

    document.dispatchEvent(
      new CustomEvent(
        'wishlist:updated',
        {
          bubbles: true,
          detail: {
            items: wishlist,
            count: wishlist.length
          }
        }
      )
    );

    return wishlist;
  }

  /* =====================================================
     AJOUT / RETRAIT
     ===================================================== */

  function toggleWishlist(
    button
  ) {

    if (!button) return;

    const handle =
      button.dataset.handle;

    if (!handle) return;

    const wishlist =
      normalizedWishlist();

    const index =
      wishlist.indexOf(handle);

    let active;

    if (index !== -1) {

      wishlist.splice(
        index,
        1
      );

      active = false;

    } else {

      wishlist.push(
        handle
      );

      active = true;
    }

    const updated =
      writeWishlist(
        wishlist
      );

    /*
     * Synchronisation immédiate
     * sans attendre un rechargement.
     */

    document
      .querySelectorAll(
        BUTTON_SELECTOR
      )
      .forEach(function (item) {

        if (
          item.dataset.handle !==
          handle
        ) {
          return;
        }

        item.classList.toggle(
          'is-active',
          active
        );

        item.setAttribute(
          'aria-pressed',
          active
            ? 'true'
            : 'false'
        );

        item.setAttribute(
          'aria-label',
          active
            ? 'Retirer des coups de cœur'
            : 'Ajouter aux coups de cœur'
        );
      });

    updateWishlistCounters(
      updated
    );

    /*
     * Evénement global.
     */

    window.dispatchEvent(
      new CustomEvent(
        'lf:wishlist:change',
        {
          detail: {
            handle: handle,
            active: active,
            items: updated,
            count: updated.length
          }
        }
      )
    );

    /*
     * Synchronisation entre
     * onglets/fenêtres.
     */

    try {

      window.dispatchEvent(
        new StorageEvent(
          'storage',
          {
            key: STORAGE_KEY,
            newValue:
              JSON.stringify(updated)
          }
        )
      );

    } catch (error) {}

    return active;
  }

  /* =====================================================
     CLIC SUR UN COEUR
     ===================================================== */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          BUTTON_SELECTOR
        );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      toggleWishlist(
        button
      );
    },
    true
  );

  /* =====================================================
     STORAGE EVENT
     Synchronisation entre onglets
     ===================================================== */

  window.addEventListener(
    'storage',
    function (event) {

      if (
        event.key ===
        STORAGE_KEY
      ) {
        syncWishlist();
      }
    }
  );

  /* =====================================================
     EVENEMENT PERSONNALISE
     Permet à une page de demander
     une synchronisation manuelle.
     ===================================================== */

  window.addEventListener(
    'lf:wishlist:sync',
    function () {
      syncWishlist();
    }
  );

  /* =====================================================
     SHOPIFY SECTION LOAD
     ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {
      syncWishlist();
    }
  );

  /* =====================================================
     INITIALISATION
     ===================================================== */

  function initWishlist() {
    syncWishlist();
  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initWishlist
    );

  } else {

    initWishlist();
  }

  /* =====================================================
     API GLOBALE
     Utile pour la page Coups de cœur
     ===================================================== */

  window.lfWishlist = {

    get: function () {
      return readWishlist();
    },

    set: function (items) {

      if (!Array.isArray(items)) {
        return;
      }

      writeWishlist(
        items.filter(Boolean)
      );

      syncWishlist();
    },

    add: function (handle) {

      if (!handle) return;

      const wishlist =
        readWishlist();

      if (
        wishlist.indexOf(handle) ===
        -1
      ) {
        wishlist.push(handle);
      }

      writeWishlist(
        wishlist
      );

      syncWishlist();
    },

    remove: function (handle) {

      if (!handle) return;

      const wishlist =
        readWishlist();

      const index =
        wishlist.indexOf(handle);

      if (index !== -1) {
        wishlist.splice(
          index,
          1
        );
      }

      writeWishlist(
        wishlist
      );

      syncWishlist();
    },

    has: function (handle) {

      return (
        readWishlist()
          .indexOf(handle) !== -1
      );
    },

    clear: function () {

      writeWishlist([]);

      syncWishlist();
    },

    sync: function () {
      return syncWishlist();
    },

    count: function () {
      return readWishlist().length;
    }
  };

})();